var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('notification'),_vm._v(" "),_c('v-main',[_c('transition',[_c('Nuxt')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }